export default __webpack_public_path__ + "static/media/German.b303aaa1.mp3";